module.exports = __webpack_public_path__ + "media/audio7.c152e3f3.wav";